import React from "react";
import { connect } from "react-redux";

import KeywordSearchField from "./keywordSearchField";
import { resetField } from "../store/actions";

const KeywordSearch = ({
	placeholder,
	searchField,
	name,
	itemLink,
	resetField,
	searchResults,
	listName,
	onResetField,
	searchAction,
	className,
	reset
}) => {
	const onSearch = (queryParams) => {
		resetField(listName, {});
		onResetField && onResetField();
		searchAction && searchAction(queryParams);
	};

	const fieldProps = {
		placeholder,
		searchField,
		name,
		itemLink,
		resetField,
		searchResults
	};
	return <KeywordSearchField className={className} {...fieldProps} reset={reset} searchAction={(event) => onSearch(event)} />;
};

const mapDispatchToProps = { resetField };

export default connect(
	null,
	mapDispatchToProps
)(KeywordSearch);
